import { createStyleSheet } from '@shared-ui/theme'
import { rf, rh, rw } from '@shared-ui/theme/scale'

// Полупрозрачные цинковые заливки/рамки скелетонов из макета — в теме нет alpha-варианта нейтрали
const STUB_FILL_STRONG = 'rgba(117,120,139,0.17)' // color dark-light theme verified
const STUB_FILL_SOFT = 'rgba(117,120,139,0.16)' // color dark-light theme verified
const STUB_STROKE_SOFT = 'rgba(117,120,139,0.2)' // color dark-light theme verified
const STUB_STROKE_STRONG = 'rgba(117,120,139,0.48)' // color dark-light theme verified

export const useCreateStyles = createStyleSheet((theme, { safe }) => ({
  container: {
    backgroundColor: theme.COLOR_BG_BASE,
    flexGrow: 1,
    paddingBottom: rh(64),
    paddingHorizontal: theme.SIZE_CONTAINER_PADDING,
    // перекрывает safe-паддинг ScreenWrapper, поэтому safe.top учитываем сами
    paddingTop: safe.top + rh(12),
  },
  avatar: {
    backgroundColor: theme.COLOR_BG_SURFACE,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 999,
    height: rw(40),
    overflow: 'hidden',
    width: rw(40),
  },
  balanceWrap: {
    alignItems: 'center',
    paddingTop: rh(36),
  },
  actionsWrap: {
    marginTop: rh(32),
  },
  bannerWrap: {
    marginTop: rh(32),
  },
  products: { marginTop: rh(32) },
  productsContent: { flexGrow: 1, gap: rw(16) },
  productTile: { flexShrink: 0 },
  productTileFlexible: { flex: 1 },
  productCard: {
    backgroundColor: theme.COLOR_BG_SURFACE,
    borderRadius: theme.SIZE_BLOCK_BORDER_RADIUS,
    flex: 1,
    padding: rw(16),
    rowGap: rh(24),
  },
  productCardHorizontal: {
    alignItems: 'flex-start',
    columnGap: rw(24),
    flexDirection: 'row',
    paddingVertical: rh(20),
  },
  productDetailsHorizontal: {
    flex: 1,
    minWidth: 0,
  },
  productLabel: {
    color: theme.COLOR_TEXT_SECONDARY,
    fontSize: rf(16),
    lineHeight: rh(22.4),
  },
  productMeta: {
    minHeight: rh(44),
  },
  productMetaIssued: {
    justifyContent: 'flex-end',
  },
  productPrice: {
    color: theme.COLOR_TEXT_PRIMARY,
    fontSize: rf(18),
    lineHeight: rh(22),
  },
  operations: {
    marginHorizontal: -theme.SIZE_CONTAINER_PADDING,
    marginTop: rh(32),
    rowGap: rh(16),
  },
  operationsPanel: { marginTop: 0 },
  sectionTitle: {
    color: theme.COLOR_TEXT_PRIMARY,
    fontSize: rf(20),
    letterSpacing: rw(-0.2),
    lineHeight: rh(26),
    paddingHorizontal: theme.SIZE_CONTAINER_PADDING,
  },
  operationsEmpty: {
    paddingVertical: rh(16),
  },
  operationsEmptyText: {
    color: theme.COLOR_TEXT_TERTIARY,
    fontSize: rf(14),
    lineHeight: rh(21),
    textAlign: 'center',
    maxWidth: rw(300),
    width: '100%',
  },
  operationsList: {
    width: '100%',
  },
  operationGroup: {
    width: '100%',
  },
  operationIcon: {
    width: rw(40),
    height: rw(40),
    borderRadius: rw(20),
    backgroundColor: theme.COLOR_BG_SURFACE,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  operationGroupTitle: {
    color: theme.COLOR_TEXT_SECONDARY,
    fontSize: rf(14),
    lineHeight: rh(20),
    paddingHorizontal: theme.SIZE_CONTAINER_PADDING,
  },
  stubWrapper: {
    height: rh(136),
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
  },
  stubCardFront: {
    backgroundColor: theme.COLOR_BG_BASE,
    borderColor: STUB_STROKE_SOFT,
    borderRadius: rw(15.192),
    borderWidth: rw(1.688),
    top: rh(60.6),
    padding: rw(13.5),
    position: 'absolute',
    left: '50%',
    transform: [{ translateX: -rw(127.865) }],
    height: rh(60.767),
    width: rw(255.729),
  },
  stubCardBack: {
    backgroundColor: theme.COLOR_BG_BASE,
    borderColor: STUB_STROKE_STRONG,
    borderRadius: rw(15.66),
    borderWidth: rw(0.844),
    padding: rw(12),
    position: 'absolute',
    left: '50%',
    top: rh(16.67),
    transform: [{ translateX: -rw(115.078) }, { rotate: '1.02deg' }],
    height: rh(52.765),
    width: rw(230.156),
  },
  stubCircleFront: {
    backgroundColor: STUB_FILL_STRONG,
    borderRadius: 999,
    height: rw(34),
    width: rw(34),
  },
  stubCircleBack: {
    backgroundColor: STUB_FILL_SOFT,
    borderRadius: 999,
    height: rw(30),
    width: rw(30),
  },
  stubLineFrontTitle: {
    backgroundColor: STUB_FILL_STRONG,
    borderRadius: rw(27),
    height: rh(12),
    width: rw(52),
  },
  stubLineFrontSub: {
    backgroundColor: STUB_FILL_STRONG,
    borderRadius: rw(27),
    height: rh(9),
    width: rw(65),
  },
  stubLineBackTitle: {
    backgroundColor: STUB_FILL_SOFT,
    borderRadius: rw(27),
    height: rh(11),
    width: rw(47),
  },
  stubLineBackSub: {
    backgroundColor: STUB_FILL_SOFT,
    borderRadius: rw(27),
    height: rh(8),
    width: rw(59),
  },
}))
